import React, { useEffect } from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import "./HousePlanning.css";
import buildingSketch from "../../assets/images/DesignDiagram.jpg";
import { housePlanningServicesData } from "../../data/ServicesData";

export default function HousePlanning() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className="house-planning-container">
      {/* Header Section */}
      <Box
        className="header-section"
        sx={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url(${buildingSketch})`,
        }}
      >
        <Container>
          <Typography variant="h3" component="h1" className="header-title">
            House Planning and Design
          </Typography>
        </Container>
      </Box>

      <Container className="content-container">
        {/* Intro Section */}
        <Box className="intro-section">
          <Typography variant="h4" gutterBottom className="intro-title">
            Key Features of Our House Plans
          </Typography>
          <Box
            sx={{
              width: "60px",
              height: "4px",
              backgroundColor: "#4285f4",
              margin: "0 auto 24px auto",
            }}
          />
          <Typography variant="body1" className="intro-text">
            At VR Builders and Promoters, we believe that a well-designed house
            plan is the foundation of a successful and harmonious home. Our team
            of experienced architects and designers works closely with each
            client to develop personalized plans that reflect their lifestyle,
            preferences, and functional needs.
          </Typography>
        </Box>

        <Grid>
          <Grid container spacing={4} className="features-grid-container">
            {housePlanningServicesData.map((feature, index) => (
              <Grid item xs={12} md={6} lg={6} key={index}>
                <Paper elevation={0} className="feature-card">
                  <Box
                    className="feature-icon"
                    sx={{ color: feature.iconColor }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    gutterBottom
                    className="feature-title"
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    className="feature-text"
                  >
                    {feature.text}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
